const R = 489;
export {
  R as READMORE_CHAR_CUTOFF
};
